/* eslint-disable react/prop-types */
import React from 'react';
import FormHelperText from '@mui/joy/FormHelperText';
import Typography from '@mui/joy/Typography';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

/**
 * Inline helper under a field — icon + short clarification (not a separate section).
 */
export default function PricingRuleFieldHint({
  children,
  icon: Icon = InfoOutlined,
  color = 'neutral.600',
}) {
  if (!children) return null;

  return (
    <FormHelperText
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.75,
        mt: 0.5,
        mx: 0,
      }}
    >
      <Icon
        aria-hidden
        sx={{
          fontSize: 16,
          mt: '1px',
          flexShrink: 0,
          color: 'primary.500',
          opacity: 0.9,
        }}
      />
      <Typography component="span" level="body-xs" sx={{ color, lineHeight: 1.45 }}>
        {children}
      </Typography>
    </FormHelperText>
  );
}
